import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
  name: 'highlight',
  standalone: false,
})
export class HighlightPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}

  transform(text: any, search: string): SafeHtml {
    // Check if the search term is a string and has a value
    if (typeof search !== 'string' || !search) {
      return text;
    }

    const textString = String(text);
    let searchTermToHighlight = search;

    // Check if the search term contains a colon to handle the 'key:value' format
    if (search.includes(':')) {
      const parts = search.split(':');
      // Use the part after the colon for highlighting, if it exists.
      if (parts.length > 1) {
        searchTermToHighlight = parts[1];
      }
    }

    // Return the original text if there's no value to highlight
    if (!searchTermToHighlight) {
      return text;
    }
    // Convert the 'text' input to a string to ensure the 'replace' method works.
    // Escape special characters in the search term to prevent regex errors.
    const escapedSearch = searchTermToHighlight.replace(
      /[.*+?^${}()|[\]\\]/g,
      '\\$&',
    );
    const regex = new RegExp(`(${escapedSearch})`, 'gi');

    // Check if the regex matches the string before attempting to replace.
    if (!textString.match(regex)) {
      return text;
    }

    const highlightedText = textString.replace(regex, `<b>$1</b>`);
    // const regex = new RegExp(`(${search})`, 'gi');
    // const highlightedText = text.replace(regex, `<b>$1</b>`);

    return this.sanitizer.bypassSecurityTrustHtml(highlightedText);
  }
}
